import CircularProgress from '@mui/material/CircularProgress';
import './index.scss'

export default function Preloader() {
    return <div className='preloaderWrap'><CircularProgress color="inherit" /></div>
}
